import { useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import CabRSL from '../../cab-rsl/CabRSL'
import Head from 'next/head'

import { useRouter } from 'next/router'

const MainFilterSearchBox = ({ setImage, currentTab, setCurrentTab }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const router = useRouter()

  const [homeFilterList, setHomeFilterList] = useState(null)

  function getMatchingObjectsByKey(value, keys) {
    return value.filter(item => keys.includes(item.key));
  }


  useEffect(() => {
    let intervalId;

    const checkForData = () => {
      const storedData = localStorage.getItem('webServiceList');
      if (storedData) {
        try {
          const parsedData = JSON.parse(storedData);

          setHomeFilterList(parsedData);
          // ✅ Safely access the first tab's key (fallback to "Cab" if not available)
          setCurrentTab(parsedData?.[0]?.key || 'Cab');

          clearInterval(intervalId); // ✅ Stop polling once data is set
        } catch (error) {
          console.error('Error parsing webServiceList:', error);
        }
      }
    };

    checkForData(); // Initial check
    intervalId = setInterval(checkForData, 1000); // ✅ Poll every 1 sec

    return () => clearInterval(intervalId); // Cleanup
  }, []);

  const { backgroundImage } = useSelector(state => state.common)

  // const handleTabClick = useCallback((tab, index) => {
  //   setCurrentTab(tab.name);
  //   setCurrentIndex(index);
  // }, [getBannerType, callBannerBackgroundApi]);

  const handleTabClick = (tab, index) => {
    if (tab?.url !== 'cab') {
      router.push({
        pathname: `/${tab?.url}`
      })
    }
  }

  return (
    <>
      <Head>
        <meta
          name='viewport'
          content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
        />
      </Head>
      <div className='tabs__content js-tabs-content'>
        <div
          className={
            'mainSearch rsl-main-search items-center bg-white pr-40 pl-40 pl-40 lg:py-60 pt-80 py-40 lg:px-40 lg:pt-5 lg:pb-20'
          }
        >
          <div className='rsl-line'>
            <div className='tab-rule'></div>
          </div>
          <div className='tabs -bookmark js-tabs'>
            <div className='tabs__controls d-flex items-center js-tabs-controls'>
              {homeFilterList?.map((tab, index) => (
                <button
                  key={tab?.key || `${tab?.name}-${index}`}  // ✅ Ensures unique keys
                  className={`tabs__button tabs__button_main px-30 rounded-100 fw-600 text-white js-tabs-button ${tab?.key === currentTab ? 'is-tab-el-active' : ''
                    }`}
                  onClick={() => handleTabClick(tab, index)}
                >

                  {currentIndex === index && tab.icon && (
                    <img
                      src={tab.icon}
                      alt='quote'
                      width='30'
                      className='mr-10'
                    />
                  )}
                  {tab?.name}
                </button>
              ))}
            </div>
          </div>
          {/* Cab Starts */}
          {currentTab === 'Cab' && <CabRSL />}

          {/* {currentTab === "Flights" && <FlightsRSL />}
       
          {currentTab === "Hotels" && <HotelsRSL />}
         
          {currentTab === "Activities" && <ActivitiesRSL />}
          
          {currentTab === "Car" && <CarRSL />}
          
          {currentTab === "Buses" && <BusRSL />}
         
          {currentTab === "Holidays" && <Holidays />}
          {currentTab === "Staycations" && <Staycations />}
          {currentTab === "Visa" && <VisaService />} */}
          {/* {currentTab === "TOUR" && <TourRSL />} */}
        </div>
        {/* End .mainSearch */}
      </div>
      {/* End serarchbox tab-content */}
    </>
  )
}

export default MainFilterSearchBox
